
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiNotificationAdviceActive as ObiNotificationAdviceActiveElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-notification-advice-active.js';
 
 
 

 
 export const ObiNotificationAdviceActive = createComponent({
   react: React,
   tagName: 'obi-notification-advice-active',
   elementClass: ObiNotificationAdviceActiveElement,
   events: {
     
   }
  });
 
 